export const en = {
  // Common
  common: {
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    create: 'Create',
    update: 'Update',
    search: 'Search',
    filter: 'Filter',
    clear: 'Clear',
    reset: 'Reset',
    submit: 'Submit',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    ok: 'OK',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    continue: 'Continue',
    finish: 'Finish',
    select: 'Select',
    selectAll: 'Select All',
    deselectAll: 'Deselect All',
    download: 'Download',
    upload: 'Upload',
    refresh: 'Refresh',
    retry: 'Retry',
    copy: 'Copy',
    share: 'Share',
    print: 'Print',
    export: 'Export',
    import: 'Import',
    settings: 'Settings',
    preferences: 'Preferences',
    profile: 'Profile',
    logout: 'Logout',
    login: 'Login',
    register: 'Register',
    forgotPassword: 'Forgot Password',
    changePassword: 'Change Password',
    required: 'Required',
    optional: 'Optional',
    name: 'Name',
    email: 'Email',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    firstName: 'First Name',
    lastName: 'Last Name',
    company: 'Company',
    phone: 'Phone',
    address: 'Address',
    city: 'City',
    state: 'State',
    zipCode: 'ZIP Code',
    country: 'Country',
    countryCode: 'Country Code',
    status: 'Status',
    active: 'Active',
    inactive: 'Inactive',
    enabled: 'Enabled',
    disabled: 'Disabled',
    date: 'Date',
    time: 'Time',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    total: 'Total',
    count: 'Count',
    results: 'Results',
    noResults: 'No results found',
    noData: 'No data available',
    page: 'Page',
    of: 'of',
    perPage: 'per page',
    showing: 'Showing',
    to: 'to',
    items: 'items',
  },

  // Navigation
  nav: {
    dashboard: 'Dashboard',
    search: 'Search',
    searchHistory: 'Search History',
    reports: 'Reports',
    users: 'Users',
    settings: 'Settings',
    profile: 'Profile',
    billing: 'Billing',
    license: 'License',
    notes: 'Notes',
    documents: 'Documents',
    statistics: 'Statistics',
    preferences: 'Preferences',
    help: 'Help',
    support: 'Support',
  },

  // Authentication
  auth: {
    welcomeBack: 'Welcome Back',
    signInAccount: 'Sign in to your account',
    signIn: 'Sign In',
    signOut: 'Sign Out',
    signUp: 'Sign Up',
    rememberMe: 'Remember Me',
    forgotPassword: 'Forgot your password?',
    resetPassword: 'Reset Password',
    emailAddress: 'Email Address',
    enterEmail: 'Enter your email address',
    enterPassword: 'Enter your password',
    newPassword: 'New Password',
    currentPassword: 'Current Password',
    confirmNewPassword: 'Confirm New Password',
    passwordChanged: 'Password changed successfully',
    loginSuccess: 'Login successful',
    logoutSuccess: 'Logout successful',
    sessionExpired: 'Your session has expired. Please login again.',
    loginFailed: 'Login failed. Please check your credentials.',
    invalidCredentials: 'Invalid email or password',
    accountLocked: 'Account temporarily locked due to multiple failed attempts',
    passwordResetSent: 'Password reset instructions sent to your email',
    userType: 'User Type',
    client: 'Client',
    clientUser: 'Client User',
  },

  // Dashboard
  dashboard: {
    welcome: 'Welcome',
    overview: 'Overview',
    quickStats: 'Quick Stats',
    recentActivity: 'Recent Activity',
    searchesThisMonth: 'Searches This Month',
    quotaUsage: 'Quota Usage',
    recentSearches: 'Recent Searches',
    noRecentSearches: 'No recent searches',
    viewAll: 'View All',
    searchQuotaDaily: 'Daily Search Quota',
    searchQuotaMonthly: 'Monthly Search Quota',
    quotaRemaining: 'Quota Remaining',
    quotaUsed: 'Quota Used',
    licenseExpires: 'License Expires',
    activeUsers: 'Active Users',
    totalReports: 'Total Reports',
    lastLogin: 'Last Login',
    quickActions: 'Quick Actions',
    newSearch: 'New Search',
    viewReports: 'View Reports',
    manageUsers: 'Manage Users',
  },

  // Search
  search: {
    trademarkSearch: 'Trademark Search',
    newSearch: 'New Search',
    searchBy: 'Search By',
    searchType: 'Search Type',
    searchQuery: 'Search Query',
    advancedSearch: 'Advanced Search',
    basicSearch: 'Basic Search',
    searchResults: 'Search Results',
    searchHistory: 'Search History',
    searchFilters: 'Search Filters',
    trademarkNumber: 'Trademark Number',
    trademarkName: 'Trademark Name',
    trademarkImage: 'Trademark Image',
    proprietorName: 'Proprietor Name',
    proprietorAddress: 'Proprietor Address',
    attorneyName: 'Attorney Name',
    attorneyAddress: 'Attorney Address',
    attorneyCode: 'Attorney Code',
    classDescription: 'Class Description',
    enterTrademarkNumber: 'Enter trademark number',
    enterTrademarkName: 'Enter trademark name',
    enterProprietorName: 'Enter proprietor name',
    uploadImage: 'Upload Image',
    selectImage: 'Select Image',
    imageUploaded: 'Image uploaded successfully',
    classes: 'Classes',
    selectClasses: 'Select Classes',
    status: 'Status',
    selectStatus: 'Select Status',
    dateRange: 'Date Range',
    fromDate: 'From Date',
    toDate: 'To Date',
    matchType: 'Match Type',
    exact: 'Exact',
    contains: 'Contains',
    startsWith: 'Starts With',
    endsWith: 'Ends With',
    fuzzy: 'Fuzzy',
    similarity: 'Similarity',
    threshold: 'Threshold',
    clearFilters: 'Clear Filters',
    applyFilters: 'Apply Filters',
    searchExecuted: 'Search executed successfully',
    searchFailed: 'Search failed',
    quotaExceeded: 'Search quota exceeded',
    searching: 'Searching...',
    resultsFound: '{count} results found',
    noResultsFound: 'No results found for your search criteria',
    refineSearch: 'Try refining your search criteria',
    saveSearch: 'Save Search',
    searchSaved: 'Search saved successfully',
    exportResults: 'Export Results',
    generateReport: 'Generate Report',
    addToReport: 'Add to Report',
    selectedResults: 'Selected Results',
    selectResults: 'Select results to add to report',
    sortBy: 'Sort By',
    relevance: 'Relevance',
    alphabetical: 'Alphabetical',
    dateCreated: 'Date Created',
    ascending: 'Ascending',
    descending: 'Descending',
    viewDetails: 'View Details',
    trademarkDetails: 'Trademark Details',
    registrationNumber: 'Registration Number',
    applicationNumber: 'Application Number',
    filingDate: 'Filing Date',
    registrationDate: 'Registration Date',
    expirationDate: 'Expiration Date',
    renewalDate: 'Renewal Date',
    trademarkClass: 'Trademark Class',
    goodsServices: 'Goods & Services',
    owner: 'Owner',
    attorney: 'Attorney',
    imageSearch: 'Image Search',
    similarImages: 'Similar Images',
    imageAnalysis: 'Image Analysis',
    confidenceScore: 'Confidence Score',
  },

  // Reports
  reports: {
    reports: 'Reports',
    myReports: 'My Reports',
    createReport: 'Create Report',
    generateReport: 'Generate Report',
    reportGenerated: 'Report generated successfully',
    reportName: 'Report Name',
    enterReportName: 'Enter report name',
    reportFormat: 'Report Format',
    reportType: 'Report Type',
    searchReport: 'Search Report',
    analysisReport: 'Analysis Report',
    comparisonReport: 'Comparison Report',
    includeImages: 'Include Images',
    includeDetails: 'Include Details',
    customization: 'Customization',
    reportHeader: 'Report Header',
    reportFooter: 'Report Footer',
    branding: 'Branding',
    companyLogo: 'Company Logo',
    reportSettings: 'Report Settings',
    downloadReport: 'Download Report',
    viewReport: 'View Report',
    shareReport: 'Share Report',
    deleteReport: 'Delete Report',
    reportDeleted: 'Report deleted successfully',
    generatingReport: 'Generating report...',
    reportReady: 'Report is ready',
    reportError: 'Error generating report',
    noReports: 'No reports created yet',
    createFirstReport: 'Create your first report',
    reportHistory: 'Report History',
    pdfFormat: 'PDF',
    excelFormat: 'Excel',
    csvFormat: 'CSV',
  },

  // Users (for Client role)
  users: {
    users: 'Users',
    userManagement: 'User Management',
    addUser: 'Add User',
    createUser: 'Create User',
    editUser: 'Edit User',
    deleteUser: 'Delete User',
    userCreated: 'User created successfully',
    userUpdated: 'User updated successfully',
    userDeleted: 'User deleted successfully',
    userDetails: 'User Details',
    userProfile: 'User Profile',
    activeUsers: 'Active Users',
    inactiveUsers: 'Inactive Users',
    totalUsers: 'Total Users',
    maxUsers: 'Max Users',
    userQuota: 'User Quota',
    dailyQuota: 'Daily Quota',
    monthlyQuota: 'Monthly Quota',
    quotaUsage: 'Quota Usage',
    searchTypes: 'Search Types',
    allowedSearchTypes: 'Allowed Search Types',
    permissions: 'Permissions',
    userStatus: 'User Status',
    lastLogin: 'Last Login',
    createdDate: 'Created Date',
    noUsers: 'No users found',
    inviteUser: 'Invite User',
    userInvited: 'User invited successfully',
    resendInvitation: 'Resend Invitation',
    userRole: 'User Role',
    setQuota: 'Set Quota',
    quotaSettings: 'Quota Settings',
    searchHistory: 'Search History',
    userActivity: 'User Activity',
    bulkActions: 'Bulk Actions',
    selectUsers: 'Select Users',
    activateUsers: 'Activate Users',
    deactivateUsers: 'Deactivate Users',
    exportUsers: 'Export Users',
  },

  // Profile
  profile: {
    myProfile: 'My Profile',
    editProfile: 'Edit Profile',
    profileUpdated: 'Profile updated successfully',
    personalInformation: 'Personal Information',
    contactInformation: 'Contact Information',
    companyInformation: 'Company Information',
    brandingSettings: 'Branding Settings',
    profilePicture: 'Profile Picture',
    uploadPicture: 'Upload Picture',
    removePicture: 'Remove Picture',
    pictureUploaded: 'Picture uploaded successfully',
    pictureRemoved: 'Picture removed successfully',
    companyLogo: 'Company Logo',
    uploadLogo: 'Upload Logo',
    removeLogo: 'Remove Logo',
    logoUploaded: 'Logo uploaded successfully',
    logoRemoved: 'Logo removed successfully',
    primaryColor: 'Primary Color',
    accentColor: 'Accent Color',
    selectColor: 'Select Color',
    colorChanged: 'Color changed successfully',
    reportHeader: 'Report Header',
    reportFooter: 'Report Footer',
    headerFooterUpdated: 'Header and footer updated successfully',
    defaultLanguage: 'Default Language',
    languageChanged: 'Language changed successfully',
    timeZone: 'Time Zone',
    timeZoneChanged: 'Time zone changed successfully',
    notificationSettings: 'Notification Settings',
    emailNotifications: 'Email Notifications',
    pushNotifications: 'Push Notifications',
    notificationPreferences: 'Notification Preferences',
    securitySettings: 'Security Settings',
    changePassword: 'Change Password',
    twoFactorAuth: 'Two-Factor Authentication',
    enable2FA: 'Enable 2FA',
    disable2FA: 'Disable 2FA',
    sessionTimeout: 'Session Timeout',
    loginHistory: 'Login History',
    connectedDevices: 'Connected Devices',
    revokeAccess: 'Revoke Access',
  },

  // Settings
  settings: {
    settings: 'Settings',
    generalSettings: 'General Settings',
    systemSettings: 'System Settings',
    accountSettings: 'Account Settings',
    billingSettings: 'Billing Settings',
    licenseSettings: 'License Settings',
    settingsUpdated: 'Settings updated successfully',
    defaultView: 'Default View',
    resultsPerPage: 'Results Per Page',
    linkBehavior: 'Link Behavior',
    sameWindow: 'Same Window',
    newTab: 'New Tab',
    newWindow: 'New Window',
    theme: 'Theme',
    lightTheme: 'Light Theme',
    darkTheme: 'Dark Theme',
    autoTheme: 'Auto Theme',
    language: 'Language',
    currency: 'Currency',
    timeFormat: '24-hour',
    dateFormat: 'Date Format',
    exportSettings: 'Export Settings',
    importSettings: 'Import Settings',
    resetSettings: 'Reset Settings',
    settingsExported: 'Settings exported successfully',
    settingsImported: 'Settings imported successfully',
    settingsReset: 'Settings reset to defaults',
  },

  // License & Billing
  license: {
    license: 'License',
    licenseInformation: 'License Information',
    currentLicense: 'Current License',
    licenseType: 'License Type',
    licenseStatus: 'License Status',
    licenseExpires: 'License Expires',
    renewLicense: 'Renew License',
    upgradeLicense: 'Upgrade License',
    downgradeLicense: 'Downgrade License',
    licenseFeatures: 'License Features',
    searchQuota: 'Search Quota',
    userLimit: 'User Limit',
    storageLimit: 'Storage Limit',
    supportLevel: 'Support Level',
    licenseKey: 'License Key',
    activationDate: 'Activation Date',
    usageStatistics: 'Usage Statistics',
    quotaUtilization: 'Quota Utilization',
    featureUsage: 'Feature Usage',
    billing: 'Billing',
    billingHistory: 'Billing History',
    paymentMethod: 'Payment Method',
    nextPayment: 'Next Payment',
    invoiceHistory: 'Invoice History',
    downloadInvoice: 'Download Invoice',
    updatePayment: 'Update Payment Method',
    paymentUpdated: 'Payment method updated',
    subscription: 'Subscription',
    subscriptionActive: 'Subscription Active',
    subscriptionExpired: 'Subscription Expired',
    autoRenewal: 'Auto Renewal',
    cancelSubscription: 'Cancel Subscription',
    planComparison: 'Plan Comparison',
    contactSales: 'Contact Sales',
  },

  // Errors & Validation
  errors: {
    required: 'This field is required',
    invalidEmail: 'Please enter a valid email address',
    invalidPassword: 'Password must be at least 8 characters long',
    passwordMismatch: 'Passwords do not match',
    invalidPhone: 'Please enter a valid phone number',
    invalidFile: 'Invalid file format',
    fileTooLarge: 'File size exceeds maximum limit',
    networkError: 'Network error. Please check your connection.',
    serverError: 'Server error. Please try again later.',
    unauthorizedAccess: 'You are not authorized to access this resource.',
    sessionExpired: 'Your session has expired. Please login again.',
    validationError: 'Please correct the errors and try again.',
    genericError: 'An unexpected error occurred. Please try again.',
    notFound: 'The requested resource was not found.',
    quotaExceeded: 'You have exceeded your search quota.',
    rateLimitExceeded: 'Too many requests. Please try again later.',
    maintenanceMode: 'System is under maintenance. Please try again later.',
    browserNotSupported: 'Your browser is not supported. Please upgrade.',
    cookiesDisabled: 'Cookies must be enabled to use this application.',
    javascriptDisabled: 'JavaScript must be enabled to use this application.',
  },

  // Success Messages
  success: {
    saved: 'Saved successfully',
    updated: 'Updated successfully',
    created: 'Created successfully',
    deleted: 'Deleted successfully',
    uploaded: 'Uploaded successfully',
    sent: 'Sent successfully',
    copied: 'Copied to clipboard',
    passwordChanged: 'Password changed successfully',
    emailVerified: 'Email verified successfully',
    settingsUpdated: 'Settings updated successfully',
    profileUpdated: 'Profile updated successfully',
    reportGenerated: 'Report generated successfully',
    exportCompleted: 'Export completed successfully',
    importCompleted: 'Import completed successfully',
    syncCompleted: 'Synchronization completed',
    operationCompleted: 'Operation completed successfully',
  },

  // Tooltips & Help
  tooltips: {
    searchHelp: 'Enter search terms to find trademarks',
    quotaInfo: 'Number of searches remaining this month',
    filterHelp: 'Use filters to refine your search results',
    exportHelp: 'Export results to PDF, Excel, or CSV format',
    shareHelp: 'Share results with team members',
    saveHelp: 'Save search for future reference',
    sortHelp: 'Sort results by relevance, date, or name',
    viewHelp: 'Switch between card, table, and list views',
    profileHelp: 'Update your profile information',
    brandingHelp: 'Customize your brand colors and logos',
    usersHelp: 'Manage team members and their permissions',
    licenseHelp: 'View license details and usage statistics',
    settingsHelp: 'Configure application preferences',
    dashboardHelp: 'Overview of your account activity',
    reportsHelp: 'Create and manage custom reports',
    notesHelp: 'Add notes to trademarks for future reference',
    documentsHelp: 'Upload and manage related documents',
  },
};

export default en;